"use client"

import { useLocale } from "next-intl"
import { useEffect } from "react"

export function LocaleScript() {
  const locale = useLocale()
  const localeMap: Record<string, string> = {
    'en-EU': 'en',
    'de-AT': 'de',
  };
  const htmlLang = localeMap[locale] || 'en';

  useEffect(() => {
    // Only update if different to avoid unnecessary DOM updates
    if (document.documentElement && document.documentElement.lang !== htmlLang) {
      document.documentElement.lang = htmlLang;
    }
  }, [htmlLang]);

  return null;
}

